import React from "react";

export default class Contact extends React.Component {
    constructor () {
        super();
        this.renderContent = this.renderContent.bind(this);
    }


    renderContent = () => {
        if (this.props.isBrowser === 1) {
            return (
                <main className="contact-container">
                    <div className="contact-content">
                        <h3 className="contact-text">Phone Number: (289)-990-5328</h3>
                        <h3 className="contact-text">Email: cyprez.pham@gmail.com</h3>
                        <br></br>
                        <p1>Please feel free to contact me should you have an queries!</p1>
                    </div>
                </main>
            );
        } else {
            return (
                <main className="contact-container">
                    <div className="contact-content">
                        <h6 className="contact-text">Phone Number: (289)-990-5328</h6>
                        <h6 className="contact-text">Email: cyprez.pham@gmail.com</h6>
                        <br></br>
                        <p1>Please feel free to contact me should you have an queries!</p1>
                    </div>
                </main>
            );
        }
    }

    render() {
        return this.renderContent();
    }
}


// WEBPACK FOOTER //
// ./src/components/Contact.js